import React from 'react';
import { articles as fallbackArticles } from '../data/siteData';
import { useCollectionData } from '../services/contentApi';
import './Resources.css';

const Resources = () => {
  const { items: articles } = useCollectionData('articles', fallbackArticles);

  return (
  <section className="section resources-section" id="resources">
    <div className="container">
      <div className="section-header">
        <div className="section-tag">📚 Resources</div>
        <h2 className="section-title">Infection Control & Procurement <span className="gradient-text">Knowledge Base</span></h2>
        <p className="section-sub">Expert guides, compliance updates, and operational best practices — designed to help healthcare procurement teams make smarter decisions.</p>
      </div>

      <div className="resources-grid">
        {articles.map((a, i) => (
          <div className="resource-card" key={a.id || i}>
            <div className="resource-top">
              <span className="resource-tag">{a.tag || a.title}</span>
              <span className="resource-read">{a.read || a.date}</span>
            </div>
            <div className="resource-icon">{a.icon || '📄'}</div>
            <h3 className="resource-title">{a.title}</h3>
            <p className="resource-desc">{a.desc || a.excerpt}</p>
            <a href={a.url || '#contact'} className="resource-link">Read Article →</a>
          </div>
        ))}
      </div>

      <div className="resources-newsletter">
        <div className="nl-content">
          <h3>📬 Stay Updated on Compliance & Supply News</h3>
          <p>Join 500+ hospital procurement professionals who receive our monthly linen management insights.</p>
        </div>
        <div className="nl-form">
          <input type="email" placeholder="your@hospital.com" className="nl-input" />
          <button className="btn-primary">Subscribe</button>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Resources;
